// project-imports
import { getRequest, postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - STRIPE ||============================== //

export async function handleStripe(action: APIAction) {
  switch (action.method) {
    case 'create-customer':
      return postRequest('/stripe/create-stripe-customer', action.data, true);
    case 'read-customer':
      return postRequest('/stripe/customer-details', action.data, true);
    case 'update-customer':
      return postRequest('/stripe/update-customer-details', action.data, true);
    case 'add-payment-method':
      return postRequest('/stripe/add-payment-method', action.data, true);
    case 'create-initial-payment':
      return postRequest('/stripe/create-initial-payment', action.data, true);
    case 'create-subscription':
      return postRequest('/stripe/create-subscription', action.data, true);
    case 'create-subscription-biannual':
      return postRequest('/stripe/create-subscription-biannual', action.data, true);
    case 'cancel-subscription':
      return postRequest('/stripe/cancel-subscription', action.data, true);
    case 'create-portal-session':
      return getRequest(`/stripe/create-portal-session/${action.id}`);
    case 'create-checkout-session':
      return postRequest('/stripe/create-checkout-session', action.data, true);
    case 'subscription-add-catalogue':
      return postRequest('/stripe/add-catalogue', action.data, true);
    case 'subscription-remove-catalogue':
      return postRequest('/stripe/remove-catalogue', action.data, true);
    case 'subscription-add-addon':
      return postRequest('/stripe/add-addon', action.data, true);
    case 'subscription-remove-addon':
      return postRequest('/stripe/remove-addon', action.data, true);
    case 'create-one-time-ai-payment':
      return postRequest('/stripe/create-one-time-ai-payment', action.data, true);
    default:
      console.info('[ApiManager > handleApiAction > handleStripe] - Unknown method');
      break;
  }
}
